class autoAddItems {
  constructor(POSSIBLE_PRODUCTS) {
    this.possible_products = POSSIBLE_PRODUCTS;
    this.cart = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
    this.autoAddItemsToCart();
  }

  isLoading(loading) {
    if(!loading) return;

    const emptyState = document.querySelector('.empty-state');
    const notEmptyCart = document.querySelector('.page-content.page-content--fluid')

    if(emptyState) {
    emptyState.innerHTML = `
      <div class="spinner">
        <svg focusable="false" width="62" height="62" class="icon icon--spinner" viewBox="25 25 50 50">
          <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
        </svg>
      </div>
    `;
    }

    if(notEmptyCart) {
      notEmptyCart.insertAdjacentHTML('afterbegin', `
        <div class="spinner" style="position: absolute; left: 50%; transform: translateX(-50%);">
          <svg focusable="false" width="62" height="62" class="icon icon--spinner" viewBox="25 25 50 50">
            <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
          </svg>
        </div>
      `);
      const cartMarkup = notEmptyCart.querySelector('.cart');
      if(cartMarkup) {
        cartMarkup.style.opacity = '0.5'
      }
    }
  }

  async autoAddItemsToCart() {
    const urlParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlParams.entries());
    if (!params.fairitems) return;
    const items = params.fairitems.split("-");
    let itemsToAdd = [];
    let count = 0;
    for (const item of items) {
    // The Cart add is only handling 20 line items at once
      if (count >= 20) break;
      const [encodedSku, quantity] = item.split(":");
      const sku = decodeURIComponent(encodedSku);
      const product = this.possible_products.find((prod) => prod.sku === sku);
      if (product) {
        const itemToAdd = { id: product.id, quantity: parseInt(quantity), properties: { _auto_added: "true" } };

        if (product.selling_plan_id && params.subscription === "true") {
          itemToAdd.selling_plan = product.selling_plan_id;
        }
        itemsToAdd.push(itemToAdd);
        count++;
      }
    }
    if (itemsToAdd.length > 0) {
      this.isLoading(true);
      await this.clearCart();
      await this.addToCart(itemsToAdd, params.code || null);
    }
    this.clearParams();
  }

  async clearCart() {
    try {
      const clearResponse = await fetch(`${window.Shopify.routes.root}cart/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      if(!clearResponse.ok) {
        throw new Error("Error clearing cart: " + clearResponse.statusText);
      }
    } catch (error) {
      console.error("Error clearing cart:", error);
    }
  }

  clearParams() {
    const url = new URL(window.location);
    url.searchParams.delete("fairitems");
    url.searchParams.delete("subscription");
    url.searchParams.delete("code");
    window.history.replaceState({}, document.title, url.toString());
  }

  async addToCart(items, code = null) {
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({items: items}),
      });
      const state = await response.json();
      if (state.errors) {
        return;
      }
      if (code) {
        await fetch(`${window.Shopify.routes.root}discount/${code}`);
      }
      await this.updateMainCartSection();
      await this.dispatchCartEvents();
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  }

async updateMainCartSection() {
  if (!window.location.pathname.includes("/cart")) return;

  // Find section that ends with "__main"
  const section = document.querySelector(
    '.shopify-section[id$="__main"]'
  );

  if (!section) return;

  const sectionId = section.id.replace("shopify-section-", "");

  const response = await fetch(
    `${window.themeVariables.routes.cartUrl}?section_id=${sectionId}`
  );

  if (!response.ok) return;

  const newHtml = await response.text();

  const newDocument = new DOMParser().parseFromString(newHtml, "text/html");

  const newSection = newDocument.querySelector(
    `.shopify-section[id$="__main"]`
  );

  if (newSection) {
    section.replaceWith(newSection);
  }
}

  async dispatchCartEvents() {
      const response2 = await fetch(`${window.themeVariables.routes.cartUrl}.js`);

      if(!response2.ok) {
        throw new Error("Error fetching updated cart: " + response2.statusText);
      }

    const cartContent = await response2.json();
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
        detail: { cart: cartContent }
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
          openMiniCart:
            window.themeVariables.settings.cartType === "drawer" &&
            document.querySelector(".drawer") === null,
        }
      })
    );
  }
}
